const PROJECTS_STATE_LOCAL_STORAGE_KEY = '@projects';
const PROJECTS_REDUCER_NAME = 'projects';

export { PROJECTS_STATE_LOCAL_STORAGE_KEY, PROJECTS_REDUCER_NAME };
